import { NgxLoggerLevel } from 'ngx-logger';

/**
 * The production environment
 */
export const environment = {
  production: true,
  name: 'demo',
  serviceHost: 'https://demo-portal-newplan.civis.bz.it',
  apiPath: '/api/newplan-portal/api/newp/api/',
  logLevel: NgxLoggerLevel.TRACE,
  availableLanguages: ['it', 'en', 'de'],
  defaultLanguage: 'it',
  iamApiPrefix: '/api/newplan-portal/api/iamauth',
  defaultContext: 'NP-PUBLIC-CONTEXT',
  messageTimeout: 5000,
  centralizedDocument: true
};
